import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconSearch({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M1.507 8.786a5.147 5.147 0 1 1 7.931-.796c.026.02.051.044.076.068l2.184 2.184c.402.402.404 1.05 0 1.455a1.027 1.027 0 0 1-1.456 0L8.058 9.515a1.05 1.05 0 0 1-.068-.076 5.148 5.148 0 0 1-6.483-.652zM2.963 7.33A3.088 3.088 0 1 0 7.33 2.963 3.088 3.088 0 0 0 2.963 7.33z"/>
        </svg>
    );
}

export default IconSearch;

